// extracted by mini-css-extract-plugin
export default {"SummaryFigure--vertical":"SummaryFigure--vertical","CardCallouts-Row":"CardCallouts-Row","CardCallouts-Callout":"CardCallouts-Callout"};